module.exports = __webpack_public_path__ + "img/oasis-1.65642a19.png";